<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="12" cols="12">
                    <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                    <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-breadcrumb/>
                    </nav>
                </b-col>
            </b-row>
        </base-header> 
        <div>
            <!-- <vue-element-loading :active="loading" :is-full-screen="true" color="#fb6340"/> -->
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6 container-padding">
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <b-card>
                            <div slot="header">
                                <h3>{{title}} </h3>
                            </div>
                            <b-row>
                                <b-col cols="12" md="12">
                                    <base-input :label="language_terms['NAME']" v-model="rfid.code" :disabled="!is_edit"></base-input>
                                </b-col>
                                <b-col cols="12">
                                    <base-input :label="language_terms['REMARKS']">
                                        <textarea
                                        class="form-control"
                                        id="exampleFormControlTextarea1"
                                        rows="3"
                                        v-model="rfid.remarks"
                                        :disabled="!is_edit">
                                        </textarea>
                                    </base-input>
                                </b-col>
                            </b-row>
                       
                        </b-card>
                    </div>
                    <div class="floating-bar">
                            <div class="floating-bar-container" align="center">
                                <b-button-group>
                                    <b-button class="transparent-btn" v-if="!is_edit" @click ="clickOnEdit()">
                                        <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                                    </b-button>
                                    <b-button class="transparent-btn" v-if="is_edit" @click="save()">
                                        <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                                    </b-button>
                                    <b-button class="transparent-btn" v-if="is_edit">
                                        <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                                    </b-button>
        
                                </b-button-group>
                            </div>
                        </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>

import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

export default 
{
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            rfid_filter: state => state.rfids.rfid_filter,
            rfid_data: state=> state.rfids.asset_data,
            is_created:state =>state.rfids.is_created,
            is_updated:state =>state.rfids.is_updated
        })
    },
    components:{
        Loading
    },
    data(){
        return{
            loading:false,
            is_edit:false,
            title:"",
            rfid:{
                code:"",
                remarks:""
            }
        }
    },
    methods:{
        async retrieve(code)
        {
            this.loading = true
            await this.$store.dispatch("rfids/fetch", {code:code});
            this.loading = false
        },
        clickOnEdit()
        {   
            this.is_edit = true
        },
        async search()
        {
            this.loading = true
            let filter = {keyword:"",active_only:"1"}
            if(this.rfid_filter)
            {
                filter = this.rfid_filter
            }
            await this.$store.dispatch('rfids/quickSearch', filter)

            this.loading = false
        },
        async save()
        {
            if(this.$route.params.id == '_new')
            {
                await this.$store.dispatch("rfids/create", this.rfid);
                if(this.is_created)
                {
                    await this.search()
                    this.$router.push("/rfids/master")
                }
            }
            else
            {
                await this.$store.dispatch("rfids/update", this.rfid);
                if(this.is_updated)
                {
                    await this.search()
                    this.$router.push("/rfids/master")
                }
            }
        }
    },
    async mounted()
    {
         this.loading = true
        if(this.$route.params.id == '_new')
        {
            this.is_edit = true
            this.title = this.language_terms['NEW_RFID']
        }
        else
        {
           
            await this.retrieve(this.$route.params.id)
            this.rfid = this.rfid_data
            this.title = this.language_terms['EDIT_INFORMATION']
        }

        this.loading = false
    }

}
</script>
